import React, { useEffect, useRef } from "react";
import style from "./ExerciseSequenceChart.module.sass";

import { generatePulseOximeterData, configPulseOximeter, initialsOf } from "./utilsMedicair";
function ExerciseSequenceChartPulseOximeter(props) {
  let { title, heartRateData, saturationData, heartRateLabel, saturationLabel, medicairData } = props;
  const chart = useRef(null);
  const canvasContainerRef = useRef();
  const data = generatePulseOximeterData(heartRateLabel, saturationLabel, heartRateData, saturationData);

  useEffect(() => {
    let canvas;
    if (canvasContainerRef.current) {
      canvas = canvasContainerRef.current.querySelector("canvas");
      if (canvas) {
        canvas.remove();
      }
      canvas = document.createElement("canvas");
      // canvas.dataset.side = side;
      canvasContainerRef.current.appendChild(canvas);
      chart.current = new Chart(canvas, configPulseOximeter(data, props.oxygenSaturationThreshold));
    }
  }, [props]);


  let hr = medicairData.dataForPulseOximeterChart[0].results[0].samples[0].map(values => values.y)
  let sp = medicairData.dataForPulseOximeterChart[1].results[0].samples[0].map(values => values.y)
  return (
    <div className={`${style.exerciseSequenceChartMedicair}`}>
      <div className={`${style.exerciseSequenceChartTitle}`}>{title}</div>
      <div className={`${style.Subtitles}`}>
        <div className={`${style.Subtitle}`}>
          <span className={`${style.HeartRateLabel}`}>{initialsOf(heartRateLabel)}</span>
          <span className={`${style.Label}`}>max</span>
          <span className={`${style.Value}`}>{props.maxHeartRate}</span>
          <span className={`${style.Label}`}>min</span>
          <span className={`${style.Value}`}>{props.minHeartRate}</span>
          <span className={`${style.Label}`}>med</span>
          <span className={`${style.Value}`}>{props.avgHeartRate}</span>
        </div>
        <div className={`${style.Subtitle}`}>
          <span className={`${style.OxygenSaturationLabel}`}>SpO<sub>2</sub></span>
          <span className={`${style.Label}`}>max</span>
          <span className={`${style.Value}`}>{props.maxOxygenSaturation}</span>
          <span className={`${style.Label}`}>min</span>
          <span className={`${style.Value}`}>{props.minOxygenSaturation}</span>
          <span className={`${style.Label}`}>med</span>
          <span className={`${style.Value}`}>{props.avgOxygenSaturation}</span>
          <span className={`${style.Label}`}>SdD</span>
          <span className={`${style.Value}`}>{props.oxygenSaturationThreshold}</span>
        </div>
      </div>
      <div className={`${style.chartContainer}`} ref={canvasContainerRef}></div>
    </div>
  );
}

export default ExerciseSequenceChartPulseOximeter;
